import React from 'react';
import type { FaqItem } from '../data/services';

export default function FaqSection({
  title = 'Common questions',
  items,
}: {
  title?: string;
  items: FaqItem[];
}) {
  if (!items.length) return null;

  return (
    <section className="py-16 sm:py-20">
      <div className="container-page">
        <div className="mx-auto max-w-4xl">
          <h2 className="font-serif text-2xl leading-snug text-ink sm:text-3xl">{title}</h2>
          <dl className="mt-8 space-y-4">
            {items.map((item) => (
              <div key={item.question} className="rounded-lg border border-black/5 bg-white p-5 shadow-sm">
                <dt className="font-semibold text-ink">{item.question}</dt>
                <dd className="mt-2 text-ink/80 leading-relaxed">{item.answer}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}
